import { XIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { ReactNode } from 'react';
import Portal from './Portal';
const Modal = ({
  children,
  isOpen,
  onClose
}: {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}): ReactNode => {
  if (!isOpen) return null;

  return (
    <Portal>
      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>
        {`
          body {
            overflow: hidden;
          }
        `}
      </style>
      <div
        className={classNames(
          'fixed inset-0 bg-black bg-opacity-25 z-50',
          'flex justify-center items-center cursor-pointer w-screen h-dvh'
        )}
        onClick={() => {
          onClose();
        }}
        data-testid='modal-backdrop'
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={classNames(
            'relative',
            'pt-huge pb-xxxl rounded-lg p-xl m-sm',
            setupForDark('bg-modal-primary'),
            'dk:max-w-screen-md dk:mx-auto',
            'shadow-[7px_9px_33px_-6px_rgba(0,0,0,1)]'
          )}
        >
          <div
            className={classNames('absolute top-md right-md', setupForDark('text-icon-secondary'))}
            onClick={onClose}
            data-testid='modal-close'
          >
            <XIcon size={24}></XIcon>
          </div>
          {children}
        </div>
      </div>
    </Portal>
  );
};

export default Modal;
